import React, { useEffect, useState } from "react";
import "./Workshop.css";
import { db } from "../../components/firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { SafeArea, Flex } from "../../components/layout";
import { Title, Text } from "../../components/ui";
import { Link, useParams } from "react-router-dom";
import { HiArrowLeft } from "react-icons/hi";
import { slugify } from "../../function";
import { logEvent, serializeError } from "../../utils/logger";

const Workshop = () => {
  const [workshop, setWorkshop] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { id: workshopId } = useParams();

  useEffect(() => {
    const fetchWorkshop = async () => {
      try {
        const docRef = doc(db, "workshops", workshopId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setWorkshop(docSnap.data());
        } else {
          setError("L'atelier n'a pas été trouvé.");
          logEvent("WARN", "DB", "Workshop not found", {
            collection: "workshops",
            documentId: workshopId,
          });
        }
      } catch (err) {
        setError("Une erreur est survenue lors du chargement de l'atelier.");
        logEvent("ERROR", "DB", "Failed to fetch workshop", {
          error: serializeError(err),
          collection: "workshops",
          documentId: workshopId,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchWorkshop();
  }, [workshopId]);

  useEffect(() => {
    if (!loading && workshop && window.location.hash) {
      setTimeout(() => {
        const hash = window.location.hash.substring(1);
        const headings = document.querySelectorAll("h3");

        for (let heading of headings) {
          const headingText = heading.innerText;
          const normalizedText = slugify(headingText);

          if (normalizedText === hash) {
            const elementPosition =
              heading.getBoundingClientRect().top + window.pageYOffset;
            // Ajoute un décalage de -100px
            window.scrollTo({
              top: elementPosition - 150,
              behavior: "smooth",
            });
            break; // Si on trouve une correspondance, on arrête la recherche
          }
        }
      }, 1000); // Laisse le temps que la page charge
    }
  }, [loading, workshop]);

  if (loading) return <Text>Chargement...</Text>;
  if (error) return <Text>{error}</Text>;

  return (
    <SafeArea className="Workshop">
      <Flex>
        <Link to={`/ateliers/${slugify(workshop.category)}`} className="back">
          <HiArrowLeft />
          {workshop ? workshop.category : "Les ateliers"}
        </Link>
      </Flex>
      <Flex type="col" gap={30}>
        <Title level="h2">{workshop.title}</Title>
        <div
          className="editor"
          dangerouslySetInnerHTML={{
            __html: workshop.content,
          }}
        />
      </Flex>
    </SafeArea>
  );
};

export default Workshop;
